import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  z-index: 10000;
  top: 0;

  > div {
    background: #fff;
    display: flex;
    width: calc(100% - 16px);
    max-width: 400px;
    padding: 16px;
    border-radius: 10px;
    justify-content: center;

    span {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: 400;
      margin-left: 8px;
      text-transform: capitalize;
    }
  }
`;

export const LoaderContainer = styled.div`
  width: 100%;
  max-width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;

  > div {
    align-items: center;
    display: flex;
  }
`;
